/**
 * @see tapd https://www.tapd.cn/53495375/prong/stories/view/1153495375001007712
 * @description 活动名称： 个人化商品推荐
 */

export { ActivityModal as Activity23616Modal } from 'src/pc/activity/23-6-16/modal'
export { ActivityHomeIcon as Activity23616HomeIcon } from 'src/pc/activity/23-6-16/home-icon'

import {
  getActivityConfigInfoHS,
  getRecommendGoodsListHS,
  getRecommendGoodsListV2HS,
} from 'src/commons/store/GameStore'
import { BeijingTime, GetChannel } from 'src/commons/utils'
import { AppStore } from 'src/pc/store/AppStore'
import { getUserInfoAsync } from 'src/pc/store/UIController'
import moment from 'moment'

export const activityNo = 'AT5751262849167439298'

export const isActivity23616Valid = (activityConfig: TGetActivityConfigInfoHS) => {
  return (
    activityConfig.activityState === 1 &&
    moment(activityConfig.endTime).valueOf() > moment(BeijingTime.now()).valueOf() &&
    moment(BeijingTime.now()).valueOf() > moment(activityConfig.beginTime).valueOf()
  )
}

export const loadActivity23616Config = async (reloadConfig?: boolean) => {
  const userInfo = await getUserInfoAsync()
  if (!userInfo || !(userInfo.vip === 2 && userInfo.super_vip_type === 'forever')) {
    return false
  }
  await BeijingTime.init()
  const config = await getActivityConfigInfoHS.Execute({ activityNo })
  const isValid = isActivity23616Valid(config)
  if (!isValid) {
    return false
  }
  const isInBlackList = userInfo.mobile && config.activityConfig.blacklist.includes(userInfo.mobile)
  if (isInBlackList) {
    return false
  }
  const now = BeijingTime.now()
  const cacheActivity23616LastViewModalDay = localStorage.getItem('activity23616-lastViewModalDay')
  let cacheActivity23616LastViewModalDayMapping = cacheActivity23616LastViewModalDay
    ? JSON.parse(cacheActivity23616LastViewModalDay)
    : null
  const lastViewModalDay =
    cacheActivity23616LastViewModalDayMapping && cacheActivity23616LastViewModalDayMapping[userInfo.uid]
      ? moment(Number(cacheActivity23616LastViewModalDayMapping[userInfo.uid]))
      : null
  const isToDay = !!lastViewModalDay && lastViewModalDay.format('YYYY-MM-DD') === moment(now).format('YYYY-MM-DD')
  const needView = lastViewModalDay
    ? isToDay || lastViewModalDay.add(config.activityConfig.intervalDays, 'd').isBefore(moment(now))
    : true
  if (!needView) {
    return false
  }
  const {
    recommendVos: recommendGoodsList,
    hgSpeedGoodsVoList,
    cloudGameTimeGoodsVoList,
  } = await getRecommendGoodsListV2HS.Execute({ activityNo, channel: GetChannel() })
  if (recommendGoodsList.length === 0) {
    return false
  }

  if (!reloadConfig) {
    cacheActivity23616LastViewModalDayMapping = cacheActivity23616LastViewModalDayMapping
      ? {
        ...cacheActivity23616LastViewModalDayMapping,
        [userInfo.uid]: now,
      }
      : {
        [userInfo.uid]: now,
      }
    localStorage.setItem('activity23616-lastViewModalDay', JSON.stringify(cacheActivity23616LastViewModalDayMapping))
    AppStore['activity-23-6-16'] = {
      modalVisible: isToDay ? false : true,
      time: moment(now).endOf('day').valueOf() - now,
      timeText: { hours: '00', minutes: '00', seconds: '00' },
      timer: window.setInterval(() => {
        if (AppStore['activity-23-6-16']) {
          AppStore['activity-23-6-16'].time -= 1000
          if (AppStore['activity-23-6-16'].time < 0) {
            window.clearInterval(AppStore['activity-23-6-16'].timer)
            AppStore['activity-23-6-16'] = null
            return
          }
          const hours = parseInt(
            `${Math.max(0, (AppStore['activity-23-6-16'].time % (1000 * 3600 * 24)) / (1000 * 3600))}`,
          )
            .toString()
            .padStart(2, '0')
          const minutes = parseInt(`${Math.max(0, (AppStore['activity-23-6-16'].time % (1000 * 3600)) / (1000 * 60))}`)
            .toString()
            .padStart(2, '0')
          const seconds = parseInt(`${Math.max(0, (AppStore['activity-23-6-16'].time % (1000 * 60)) / 1000)}`)
            .toString()
            .padStart(2, '0')
          AppStore['activity-23-6-16'].timeText = { hours, minutes, seconds }
        }
      }, 1000),
      recommendGoodsList: recommendGoodsList,
      hgSpeedGoodsVoList: hgSpeedGoodsVoList?.sort((a, b) => Number(a.sort) - Number(b.sort)).splice(0, 4),
      cloudGameTimeGoodsVoList: cloudGameTimeGoodsVoList?.sort((a, b) => Number(a.sort) - Number(b.sort)).splice(0, 4),
    }
  }
  return true
}
